import {DAILY_PRIZE_MODAL_VISIBLE, END_OF_GAME_MODAL_VISIBLE, GAME_RESULTS_MODAL_VISIBLE} from '../constants/config';
import DailyPrizeModal from './DailyPrizeModal';
import {GameResultsModal} from './GameResultsModal';
import {EndOfGameModal} from './EndOfGameModal';
import YettelPetakWizardModal from './YettelPetakWizardModal';
import {useSearchParams} from 'react-router-dom';
import {SEARCH_PARAMS} from '../constants/searchParamNames';
import QuestionnaireModal from "./Questionnaire.tsx";
import {ModalID, modalPriorities} from "../config/modalQueueConfig.ts";

const Modals = () => {
  const [searchParams] = useSearchParams();
  const jweToken = searchParams.get(SEARCH_PARAMS.TOKEN);

  if (jweToken) return null;

  const visibleModals: { id: ModalID; isVisible: boolean }[] = [
    { id: ModalID.DAILY_PRIZE, isVisible: DAILY_PRIZE_MODAL_VISIBLE === 'true' },
    { id: ModalID.END_OF_GAME, isVisible: END_OF_GAME_MODAL_VISIBLE === 'true' },
    { id: ModalID.GAME_RESULTS, isVisible: GAME_RESULTS_MODAL_VISIBLE === 'true' },
    { id: ModalID.YETTEL_WIZARD, isVisible: true },
    { id: ModalID.QUESTIONNAIRE, isVisible: true },
    { id: ModalID.NEWSLETTER, isVisible: true },
  ];

  const activeModals = visibleModals
    .filter(modal => modal.isVisible)
    .sort((a, b) => modalPriorities[b.id] - modalPriorities[a.id]); // Descending

  const topModal = activeModals[0]?.id;

  return (
    <>
      {topModal === ModalID.DAILY_PRIZE && <DailyPrizeModal />}
      {topModal === ModalID.END_OF_GAME && <EndOfGameModal />}
      {topModal === ModalID.GAME_RESULTS && <GameResultsModal />}
      {topModal === ModalID.YETTEL_WIZARD && <YettelPetakWizardModal />}
      {topModal === ModalID.QUESTIONNAIRE && <QuestionnaireModal />}
    </>
  );
};
export default Modals;
